import { Container } from "@mui/material";
import Portal from "../../componentes/PortalInvestigacion";

export const HomePage:React.FC<{}> = () => {
    return(
     <Container sx={{mt:4,mb:4}}>
        <Portal />
     </Container>
    );
}